import { render, staticRenderFns } from "./dup-list.vue?vue&type=template&id=138c0541"
import script from "./dup-list.vue?vue&type=script&lang=js"
export * from "./dup-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports